<template>
    <a class="tips_btn mt-2 d-block pointer" @click="toggleTestTools">
      <img src="@/assets/image/ai/test_btn.png" alt="" class="object-contain">
    </a>
  </template>
  
  <script>
  import Recorder from 'js-audio-recorder'
  const Swal = require('sweetalert2')
  let recorder = new Recorder()
  export default {
    name: 'testingTools',
    data() {
      return {
        isRecording: false,
        audioData: null,
        recordRefTest: null,
        timeOutProcessId: null,
        drawRecordId: null,
      }
    },
    computed: {
      isCheckbox() {
        return localStorage.getItem('hide_tips') === 'true'
      },
    },
    methods: {
      setTimeoutFun() {
        this.timeOutProcessId = setTimeout(() => {
          this.toggleRecord()
        }, 500)
      },
      toggleRecord() {
        if (!this.isRecording) {
          this.startRecord()
        } else {
          this.clickStopRecord()
        }
      },
      startRecord() {
        if (!this.isRecording) {
          recorder.start().then(() => {
            this.drawRecord()
            this.isRecording = true
          }).catch((error) => {
            console.log(error)
            recorder.stop()
            this.isRecording = false
          })
        }
      },
      clickStopRecord() {
        recorder.stop()
        this.audioData = recorder.getWAVBlob()
        this.isRecording = false
      },
      stopRecord() {
        recorder.stop()
        this.isRecording = false
      },
      drawRecord() {
        this.drawRecordId = requestAnimationFrame(this.drawRecord)
        this.drawWave({
          canvas: this.recordRefTest,
          dataArray: recorder.getRecordAnalyseData(),
          bgcolor: 'rgba(200, 200, 200, 0)',
          lineWidth: 2,
          lineColor: 'rgb(255, 255, 255)',
        })
      },
      drawWave({ canvas, dataArray, bgcolor = 'rgb(200, 200, 200)', lineWidth = 2, lineColor = 'rgb(0, 0, 0)' }) {
        if (!canvas) return
        canvas.width = 144
        canvas.height = 144
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = bgcolor
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.lineWidth = lineWidth
        ctx.strokeStyle = lineColor
        ctx.beginPath()
        let x = 0
        const sliceWidth = canvas.width / dataArray.length
        for (let i = 0; i < dataArray.length; i++) {
          const v = dataArray[i] / 128
          const y = (v * canvas.height) / 2
          if (i === 0) {
            ctx.moveTo(x, y)
          } else {
            ctx.lineTo(x, y)
          }
          x += sliceWidth
        }
        ctx.lineTo(canvas.width, canvas.height / 2)
        ctx.stroke()
      },
      toggleTestTools() {
        const htmlText = `
          <div class="h-100 d-flex flex-column justify-content-between align-items-center rounded p-3">
            <div class="mb-3">
              <div class="rounded-circle p-2">
                <div class="swal_record_img">
                  <canvas id="recordRefTest" class="swal_canvas_test"></canvas>
                </div>
              </div>
            </div>
            <div class="text-center">
              <p class="swal_text">
                請對著麥克風說話，線條會隨聲音波動。<br/>若無反應，請確認麥克風權限已開啟。
              </p>
            </div>
          </div>
        `
  
        Swal.fire({
          html: htmlText,
          showDenyButton: false,
          focusConfirm: false,
          confirmButtonText: '關閉',
          title: '設備測試',
          position: window.innerWidth < 768 ? 'top' : 'center',
          customClass: {
            title: 'text-white',
            popup: 'p-0',
            header: 'justify-content-center align-items-center swal_tips',
            htmlContainer: 'text-left',
            actions: 'm-0 mb-3',
            confirmButton: 'btn-deny m-0',
            footer: 'm-0 p-2 pb-3 border-0',
          },
          didOpen: async () => {
            await this.$nextTick()
            this.recordRefTest = document.getElementById('recordRefTest')
            this.setTimeoutFun()
          },
          willClose: () => {
            if (this.isRecording) this.stopRecord()
          }
        })
      },
    },
    mounted() {
      navigator.mediaDevices.getUserMedia({ audio: true })
      // this.toggleTestTools()
    },
    beforeDestroy() {
      if (this.isRecording) {
        this.stopRecord()
      }
      clearTimeout(this.timeOutProcessId)
      cancelAnimationFrame(this.drawRecordId)
    }
  };
  </script>
  
  <style>
  .swal_item_img {
    max-width: 178px;
    max-height: 178px;
  }
  .swal_record_img {
    width: 144px;
    height: 144px;
    background-image: url('~@/assets/image/ai/recording_img2.png');
    background-size: 144px;
  }
  .swal_canvas_test {
    width: 100%;
    height: 100%;
    max-width: 144px;
    max-height: 144px;
  }
  .object-contain {
    object-fit: contain;
  }
  .text-nowrap {
    white-space: nowrap;
  }
  .swal_text {
    font-weight: 400;
    font-size: 1.125rem;
    line-height: 1.75rem;
    text-align: center;
  }
  </style>
  